import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.mjs";import{__require as r}from"../international_address_autocomplete/Lookup.mjs";var e=o(r());export{e as default};
